import { getSubcriberWeb } from '@/core/api'
export default {
  namespaced: true,
  state: {
    client: sessionStorage.getItem('client')
      ? JSON.parse(sessionStorage.getItem('client'))
      : false,
    ceramicsCollections: sessionStorage.getItem('ceramicsCollections')
      ? JSON.parse(sessionStorage.getItem('ceramicsCollections'))
      : false,
    articlesCollections: sessionStorage.getItem('articlesCollections')
      ? JSON.parse(sessionStorage.getItem('articlesCollections'))
      : false,
    subscriber: sessionStorage.getItem('subscriber')
      ? JSON.parse(sessionStorage.getItem('subscriber'))
      : false
  },
  mutations: {
    fetch(state, site) {
      if (site.client) {
        state.client = site.client
        state.ceramicsCollections = site.client.ceramics
        state.articlesCollections = site.client.articles
        sessionStorage.setItem('client', JSON.stringify(site.subscriber))
        sessionStorage.setItem(
          'ceramicsCollections',
          JSON.stringify(site.client.ceramics)
        )
        sessionStorage.setItem(
          'articlesCollections',
          JSON.stringify(site.client.articles)
        )
      }
      if (site.subscriber) {
        state.subscriber = site.subscriber
        sessionStorage.setItem('subscriber', JSON.stringify(site.subscriber))
        sessionStorage.setItem(
          'wxOpenId',
          JSON.stringify(site.subscriber.open_id)
        )
      }
    },
    logout(state) {
      state.client = null
      state.ceramicsCollections = null
      state.articlesCollections = null
      state.subscriber = null
      sessionStorage.removeItem('client')
      sessionStorage.removeItem('ceramicsCollections')
      sessionStorage.removeItem('articlesCollections')
      sessionStorage.removeItem('subscriber')
      sessionStorage.removeItem('wxOpenId')
    }
  },
  actions: {
    // 获取首页数据
    async fetch({ commit }) {
      if (
        sessionStorage.getItem('site') ||
        !sessionStorage.getItem('wxOpenId')
      ) {
        return false
      }

      let res = await getSubcriberWeb()
      // console.log(res) // eslint-disable-line no-console
      if (res.status === 200) {
        commit('fetch', res.data)
      }
    },
    // 删除首页数据
    logout({ commit }) {
      commit('logout')
    }
  },
  getters: {
    client: state => {
      return state.client
    },
    ceramicsCollections: state => {
      return state.ceramicsCollections
    },
    articlesCollections: state => {
      return state.articlesCollections
    },
    subscriber: state => {
      return state.subscriber
    }
  }
}
